module.exports = __webpack_public_path__ + "img/goldregen-2020-023.d0cad6f7.jpg";